var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.914062,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#EAE6FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3550_31422)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.9624 28.6391L42.7904 24.5401C42.1804 22.4051 40.2024 20.9141 37.9824 20.9141H37.0004V24.9141C36.9944 26.2221 35.0054 26.2211 35.0004 24.9141V20.9141H29.0004V24.9141C28.9944 26.2221 27.0064 26.2211 27.0004 24.9141V20.9141H26.0174C23.7974 20.9141 21.8204 22.4051 21.2094 24.5401L20.0394 28.6391C19.8784 29.7051 20.3534 30.7771 21.0004 31.5321V40.9141C21.0004 43.1201 22.7944 44.9141 25.0004 44.9141H31.0004C33.2064 44.9141 35.0004 43.1201 35.0004 40.9141V32.3581C35.3784 32.1371 35.7144 31.8601 36.0004 31.5321C36.7344 32.3721 37.7994 32.9141 39.0004 32.9141H40.0004C40.3474 32.9141 40.6784 32.8561 41.0004 32.7721V43.9141C41.0064 45.2221 42.9954 45.2211 43.0004 43.9141V31.5321C43.6484 30.7781 44.1224 29.7061 43.9624 28.6391ZM33.0004 37.9141H23.0004V32.7721C23.3224 32.8561 23.6534 32.9141 24.0004 32.9141H25.0004C26.2004 32.9141 27.2664 32.3721 28.0004 31.5321C28.7344 32.3721 29.8004 32.9141 31.0004 32.9141H33.0004V37.9141Z",
    fill: "#6F4EF6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3550_31422"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(20 20.9141)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon (2).dd13fbc466133e7f3060db60185f46de.svg";
export { ForwardRef as ReactComponent };